module.exports = __webpack_public_path__ + "static/media/practice-question-divider.564541d1.png";